import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import { MatSelectModule } from '@angular/material/select';

import { AdvanceSearchService } from '../../../services/Advance-search/advance-search.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-update-all-fc',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule
  ],
  templateUrl: './update-all-fc.component.html',
  styleUrls: [
    './update-all-fc.component.scss',
    '../../../../common-style/dropdown.scss'
  ]
})
// export class UpdateAllFcComponent {

//   fc!: string;

//   showMapping: boolean = false;

//   targetMembers: any[] = [];

//   constructor(
//     @Inject(MAT_DIALOG_DATA)
//     public data: any,

//     private dialogRef:
//       MatDialogRef<UpdateAllFcComponent>,

//     private advanceSearch:
//       AdvanceSearchService,

//     private toaster:
//       ToastService
//   ) {

//     console.log(this.data);

//   }

//   close(): void {

//     this.dialogRef.close();

//   }

//   continue(): void {

//     // STEP 1
//     if (!this.showMapping) {

//       this.validateFC(this.fc);

//       return;

//     }

//     // STEP 2 FINAL SUBMIT

//     const mappedMembers =
//       this.data.profileList.map(
//         (member: any) => {

//           return {

//             oldDevoteeId:
//               member.devoteeId,

//             newDevoteeId:
//               member
//                 .selectedMappedDevotee
//                 ?.devoteeId

//           };

//         }
//       );

//     const payload = {

//       familyCode:
//         this.data.devoteeFamilyCode,

//       newFamilyCode:
//         this.fc,

//       mappedMembers

//     };

//     console.log(
//       'FINAL PAYLOAD',
//       payload
//     );

//     // this.advanceSearch
//     //   .UpdateAllFamilyCode(payload)
//     //   .subscribe({

//     //     next: (res: any) => {

//     //       this.toaster.success(
//     //         'Family code updated successfully'
//     //       );

//     //       this.dialogRef.close({

//     //         success: true

//     //       });

//     //     },

//     //     error: (err: any) => {

//     //       this.toaster.error(
//     //         err.error.message
//     //       );

//     //     }

//     //   });

//   }

//   validateFC(fc: string): void {

//     if (
//       fc?.length === 12 &&
//       fc !== this.data.devoteeFamilyCode
//     ) {

//       const payload = {

//         familyCode:
//           this.data.devoteeFamilyCode,

//         newFamilyCode:
//           fc

//       };

//       this.advanceSearch
//         .ValidateNewFc(payload)
//         .subscribe({

//           next: (res: any) => {

//             console.log(
//               'VALIDATE RESPONSE',
//               res
//             );

//             // MEMBERS ALREADY EXIST

//             if (
//               res?.data?.accountExists === true
//             ) {

//               this.toaster.error(
//                 'Members already exist. Please update individually.'
//               );

//               return;

//             }

//             // SHOW NEXT STEP

//             this.showMapping = true;

//             // FETCH TARGET MEMBERS

//             this.fetchTargetMembers(fc);

//           },

//           error: (err: any) => {

//             console.log(err);

//             this.toaster.error(
//               err.error.message
//             );

//           }

//         });

//     }

//   }

//   fetchTargetMembers(
//     familyCode: string
//   ): void {

//     this.advanceSearch
//       .fetchPhilDetails(familyCode)
//       .subscribe({

//         next: (res: any) => {

//           console.log(
//             'TARGET MEMBERS',
//             res
//           );

//           this.targetMembers =
//             res?.data || [];

//         },

//         error: (err: any) => {

//           console.log(err);

//           this.toaster.error(
//             err.error.message
//           );

//         }

//       });

//   }

//  getFilteredMembers(
//   currentMember: any
// ): any[] {

//   return this.targetMembers.filter(
//     (target: any) => {

//       return !this.data.profileList.some(

//         (profile: any) =>

//           profile !== currentMember &&

//           profile.selectedMappedDevotee
//             ?.memberCode ===
//           target.memberCode

//       );

//     }

//   );

// }

// }

export class UpdateAllFcComponent {

  fc!: string;

  showMapping: boolean = false;

  showAgreement: boolean = false;

  targetMembers: any[] = [];

  agreementName: string = '';

  selectedRelation: string = '';

  relationName: string = '';

  place: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,

    private dialogRef:
      MatDialogRef<UpdateAllFcComponent>,

    private advanceSearch:
      AdvanceSearchService,

    private toaster:
      ToastService
  ) {

    console.log(this.data);
    const primaryMember =
  this.data.profileList.find(
    (member: any) =>
      member.isPrimaryDevotee
  );

if (primaryMember) {

  this.agreementName = `

    ${primaryMember.devoteeFirstName || ''}

    ${primaryMember.devoteeMiddleName || ''}

    ${primaryMember.devoteeLastName || ''}

  `.replace(/\s+/g, ' ').trim();

}

  }

  close(): void {

    this.dialogRef.close();

  }

  continue(): void {

    // STEP 1

    if (!this.showMapping) {

      this.validateFC(this.fc);

      return;

    }

    // STEP 2 -> SHOW AGREEMENT
if (
  this.showMapping &&
  !this.showAgreement
) {

  this.showAgreement = true;

  return;

}

    // STEP 3 FINAL SUBMIT

  const mappedMembers =
  this.data.profileList.map(
    (member: any) => {

      const isPrimary =
        member.isPrimaryDevotee;

      return {

        devoteeId:
          member.devoteeId,

        // MEMBER CODE ONLY FOR PRIMARY DEVOTEE

        ...(isPrimary && {
          memberCode:
            member
              .selectedMappedDevotee
              ?.memberCode
        })

      };

    }
  );

  const payload = {

  familyCode:
    this.data.devoteeFamilyCode,

  newFamilyCode:
    this.fc,

  agreementContent: `

    I ${this.agreementName}
    ${this.selectedRelation}
    ${this.relationName}
    from ${this.place}

  `,

  place:
    this.place,

  members:
    mappedMembers

};

    console.log(
      'FINAL PAYLOAD',
      payload
    );

    this.advanceSearch
      .UpdateAllFamilyCode(payload)
      .subscribe({

        next: (res: any) => {

          this.toaster.success(
            'Family code updated successfully'
          );

          this.dialogRef.close({

            success: true,
            newFamilyCode: this.fc

          });

        },

        error: (err: any) => {

          this.toaster.error(
            err.error.message
          );

        }

      });

  }

  validateFC(fc: string): void {

    if (
      fc?.length === 12 &&
      fc !== this.data.devoteeFamilyCode
    ) {

      const payload = {

        familyCode:
          this.data.devoteeFamilyCode,

        newFamilyCode:
          fc

      };

      this.advanceSearch
        .ValidateNewFc(payload)
        .subscribe({

          next: (res: any) => {

            console.log(
              'VALIDATE RESPONSE',
              res
            );

            if (
              res?.data?.accountExists === true
            ) {

              this.toaster.error(
                'Members already exist. Please update individually.'
              );

              return;

            }

            this.showMapping = true;

            this.fetchTargetMembers(fc);

          },

          error: (err: any) => {

            console.log(err);

            this.toaster.error(
              err.error.message
            );

          }

        });

    }

  }

  fetchTargetMembers(
    familyCode: string
  ): void {

    this.advanceSearch
      .fetchPhilDetails(familyCode)
      .subscribe({

        next: (res: any) => {

          console.log(
            'TARGET MEMBERS',
            res
          );

          this.targetMembers =
            res?.data || [];

        },

        error: (err: any) => {

          console.log(err);

          this.toaster.error(
            err.error.message
          );

        }

      });

  }

  getFilteredMembers(
    currentMember: any
  ): any[] {

    return this.targetMembers.filter(
      (target: any) => {

        return !this.data.profileList.some(

          (profile: any) =>

            profile !== currentMember &&

            profile.selectedMappedDevotee
              ?.memberCode ===
            target.memberCode

        );

      }

    );

  }

}